// extracted by mini-css-extract-plugin
module.exports = {"container":"FormHeader_container__1O3UB","title":"FormHeader_title__2uS_v","button":"FormHeader_button__1HRsD","icon":"FormHeader_icon__2w2ud"};